export default __webpack_public_path__ + "static/media/travellers_Pay_home.5c0cf150.jpg";